// extracted by mini-css-extract-plugin
export default {"datePickerFallback":"_HqTr","dateInput":"Si5Z6","plusIcon":"VXlCS"};